import { render } from "./createConfigSimulatorComponent.vue?vue&type=template&id=626c53c2&scoped=true"
import script from "./createConfigSimulatorComponent.vue?vue&type=script&lang=js"
export * from "./createConfigSimulatorComponent.vue?vue&type=script&lang=js"

import "./createConfigSimulatorComponent.vue?vue&type=style&index=0&id=626c53c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626c53c2"]])

export default __exports__